var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStress1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 156 156",
    style: {
      enableBackground: "new 0 0 156 156"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M143.8,1.1c5.8,0,10.5,4.7,10.5,10.5v132c0,5.8-4.7,10.5-10.5,10.5h-132c-5.8,0-10.5-4.7-10.5-10.5v-132 C1.3,5.8,6,1.1,11.8,1.1H143.8 M143.8-0.4h-132c-6.6,0-12,5.4-12,12v132c0,6.6,5.4,12,12,12h132c6.6,0,12-5.4,12-12v-132 C155.8,5,150.4-0.4,143.8-0.4L143.8-0.4z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M78,146.5c-37.8,0-68.5-30.7-68.5-68.5C9.5,40.2,40.2,9.5,78,9.5c37.8,0,68.5,30.7,68.5,68.5 C146.5,115.8,115.8,146.5,78,146.5z M78,14.3c-35.1,0-63.7,28.6-63.7,63.7s28.6,63.7,63.7,63.7s63.7-28.6,63.7-63.7 S113.1,14.3,78,14.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7,63.6c1.2-1,3.5-1.5,5-0.9c4.4,1.5,10.8,1.6,19.4,0c2-0.4,3.7,0.3,3.9,1.4s-1.2,2.3-3.2,2.7 c-10.3,1.9-18.6,1.8-24.6-0.3C93.7,65.9,93.5,64.6,94.7,63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,64.9c1.2,1.1,1,2.3-0.6,2.8c-6.1,2-14.3,1.9-24.6-0.2c-2-0.4-3.3-1.6-3.1-2.7s2-1.7,3.9-1.3c8.6,1.7,15,1.8,19.4,0.4 C60.6,63.3,62.8,63.8,64,64.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4,95.5c6.8,16.5,22.5,27.5,40,28c18.8,0.5,36.1-11.1,43-29"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStress1);
export default __webpack_public_path__ + "static/media/Stress1.35151c012148bd300b1a4ef2d93ff243.svg";
export { ForwardRef as ReactComponent };